var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "composite-selector" },
    [
      _c("span", [_vm._v(_vm._s(_vm.name) + "：")]),
      _vm._v(" "),
      _c("el-switch", {
        attrs: {
          "active-text": _vm.activeText,
          "inactive-text": _vm.inactiveText,
        },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }